// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, Link, Typography, } from '@mui/material';

// TODO: Import MUI icon
import { Language } from '@mui/icons-material';

// TODO: Import context
import { Context, } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component
import { ContentTitle, } from '../../Common/TypographyTYH';

const BoxEducationInfo = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component BoxEducationInfo Rendered');

    // TODO: Define useContext
    const { language } = React.useContext(Context);

    // TODO: Define variable
    const localEducation = [
        { name: '大學聯合招生辦法 (JUPAS)', url: 'https://www.jupas.edu.hk/en/' },
        { name: '專上課程電子預先報名平台 (E-APP)', url: 'https://www.eapp.gov.hk/' },
        { name: '指定專業／界別課程資助計劃 (SSSDP)', url: 'https://www.cspe.edu.hk/tc/sssdp/index.html' },
        { name: '自資專上教育資訊平台 (CONCOURSE)', url: 'https://www.cspe.edu.hk/tc/index.html' },
        { name: '經評審自資專上課程資料網 (IPASS)', url: 'https://www.cspe.edu.hk/tc/ipass/index.html' },
        { name: 'e導航 (本地學士學位、副學士、高級文憑等課程搜尋器)', url: 'https://enavigator.edb.hkedcity.net/main/index.php' },
        { name: '職業訓練局課程 (VTC)', url: 'http://www.vtc.edu.hk/html/tc/' },
        { name: '自資高等教育聯盟 (FSTE)', url: 'https://www.fste.edu.hk/tc/' },
        { name: '資歷架構 (QF)', url: 'https://www.hkqf.gov.hk/tc/home/index.html' },
        { name: '資歷名冊', url: 'https://www.hkqr.gov.hk/HKQRPRD/web/hkqr-tc/' },
        { name: '應用教育文憑學生資源平台 (DAE)', url: 'https://learning.dae.edu.hk/' }
    ];

    // Non-local education resources
    const nonLocalEducation = [
        { name: '內地升學', url: 'https://lifeplanning.edb.gov.hk/tc/study/non-local-further-study/further-studies-mainland-china.html' },
        { name: '香島專科學校香島內地升學資源中心', url: 'https://chinaeduguide.edu.hk/cu6320/cuw_home.php' },
        { name: '「台灣海外聯合招生委員會」網頁', url: 'https://cmn-hant.overseas.ncnu.edu.tw/' },
        { name: 'EF (海升遊學及留學機構)', url: 'https://www.ef.com.hk/' },
        { name: '英國文化協會', url: 'https://www.britishcouncil.hk/' },
        { name: '英國升學', url: 'http://www.educationuk.org/global/' },
        { name: '美國升學', url: 'https://educationusa.state.gov/' },
        { name: '澳洲升學', url: 'https://www.studyaustralia.gov.au/' },
        { name: '加拿大升學', url: 'http://www.studying-in-canada.org/' }
    ];

    // Career information resources
    const careerInformation = [
        { name: '「Holland 職業代碼興趣測試」', url: 'https://eduplus.hk/dse/game.jsp' },
        { name: 'MBTI 十六型人格測試', url: 'https://www.apesk.com/mbti/dati_tw.asp' },
        { name: 'CV360 (全方位履歷表)', url: 'https://cv360.clap.hk/zh/index.php' },
        { name: '教育局生涯規劃網頁：職業資料庫及職業短片 (以Holland 職業代碼分類)', url: 'https://portfolio.lifeplanning.edb.gov.hk/occupations/?lang=chinese' },
        { name: '教育局生涯規劃網頁：職業資訊', url: 'https://lifeplanning.edb.gov.hk/tc/index.html' },
        { name: '青年就業起點 (YES)', url: 'https://www.e-start.gov.hk/' },
        { name: '展翅青見計劃', url: 'https://www.yes.labour.gov.hk/Home?c=zh-hk' },
        { name: '僱員再培訓局(ERB)', url: 'https://www.erb.org/tc/home' },
        { name: '香港青年協會生涯規劃探索', url: 'https://yen.hkfyg.org.hk/lifeplanning/' },
        { name: '《賽馬會鼓掌創你程》計劃 (CLAP)', url: 'https://clap.hk/?lang=zh-hant' },
        { name: '香港輔導教師協會升學就業資訊網', url: 'https://www.hkacmgm.org/' },
        { name: '學友社', url: 'https://hyc.org.hk' },
        { name: '學友社一站式學生資訊網站', url: 'https://student.hk/home' }
    ];

    // TODO: Define event
    React.useEffect(() => { window.scrollTo(0, 0); }, []);

    // TODO: Return component
    const ResourceList = ({ items }) => (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, my: 2 }}>
            {items.map((item, index) => (
                <Typography key={index} sx={{ display: 'flex', gap: 1, width: { xs: 1, sm: 280 } }}>
                    <Language color="info" />
                    <Link href={item.url} target="_blank" rel="noopener">
                        {item.name}
                    </Link>
                </Typography>
            ))}
        </Box>
    );

    return (
        <Box>
            <ContentTitle text={Text.StudentDevelopment.LifePlanning.EducationInfo.Title[language]} />
            <Typography variant="body1">{Text.StudentDevelopment.LifePlanning.EducationInfo.LocalEducation[language]}</Typography>
            <ResourceList items={localEducation} />
            <Typography variant="body1">{Text.StudentDevelopment.LifePlanning.EducationInfo.NonLocalEducation[language]}</Typography>
            <ResourceList items={nonLocalEducation} />
            <Typography variant="body1">{Text.StudentDevelopment.LifePlanning.EducationInfo.CareerInfo[language]}</Typography>
            <ResourceList items={careerInformation} />
        </Box>
    );
}

export default BoxEducationInfo;